"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1429],{

/***/ 1429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ PageMetaData; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var utilities_vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(29387);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(70178);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/remove-markdown/index.js
var remove_markdown = __webpack_require__(26525);
var remove_markdown_default = /*#__PURE__*/__webpack_require__.n(remove_markdown);
;// CONCATENATED MODULE: ./components/atomic/PageMetaData/PageMetaData.js














var PageMetaData = function(param) {
    var title = param.title, description = param.description, pageUrl = param.pageUrl, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical, _image = param.image, image = _image === void 0 ? null : _image, _collectionPage = param.collectionPage, collectionPage = _collectionPage === void 0 ? null : _collectionPage, _noIndex = param.noIndex, noIndex = _noIndex === void 0 ? false : _noIndex, _blogArticle = param.blogArticle, blogArticle = _blogArticle === void 0 ? null : _blogArticle, _faqs = param.faqs, faqs = _faqs === void 0 ? null : _faqs, _isHomePage = param.isHomePage, isHomePage = _isHomePage === void 0 ? false : _isHomePage, _vehicle = param.vehicle, vehicle = _vehicle === void 0 ? null : _vehicle, _leaseProfile = param.leaseProfile, leaseProfile = _leaseProfile === void 0 ? null : _leaseProfile, _results = param.results, results = _results === void 0 ? null : _results;
    dayjs_min_default().extend((utc_default()));
    dayjs_min_default().extend((timezone_default()));
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    var contentExists = !!leaseProfile && !!vehicle && !!leaseProfile.term && !!vehicle.id;
    var url = "".concat("https://www.leaseloco.com").concat(pageUrl);
    var ref1 = (0,react.useState)(""), prevPageUrl = ref1[0], setPrevPageUrl = ref1[1];
    var ref2 = (0,react.useState)(""), prevTitle = ref2[0], setPrevTitle = ref2[1];
    (0,react.useEffect)(function() {
        if (router.isReady && prevTitle !== title && prevPageUrl !== pageUrl) {
            setPrevTitle(title);
            setPrevPageUrl(pageUrl);
            (0,utilities_vehicle/* addToDataLayer */.Bk)({
                event: "virtual-page-view",
                pageUrl: "".concat("https://www.leaseloco.com").concat(pageUrl),
                pagePath: pageUrl,
                pageTitle: title,
                pageHostname: "https://www.leaseloco.com",
                experimentGroup: experimentGroup
            });
        }
    }, [
        pageUrl,
        title,
        router.isReady,
        experimentGroup,
        prevTitle,
        prevPageUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "57x57",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-57x57.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "60x60",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-60x60.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "72x72",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-72x72.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-76x76.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "114x114",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-114x114.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-120x120.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "144x144",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-144x144.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-152x152.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "".concat("https://www.leaseloco.com", "/apple-icon-180x180.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "".concat("https://www.leaseloco.com", "/android-icon-192x192.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "".concat("https://www.leaseloco.com", "/favicon-32x32.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "96x96",
                href: "".concat("https://www.leaseloco.com", "/favicon-96x96.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "".concat("https://www.leaseloco.com", "/favicon-16x16.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                crossOrigin: "anonymous",
                href: "".concat("https://www.leaseloco.com", "/manifest.json")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "".concat("https://www.leaseloco.com", "/favicon.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ffffff"
            }, "ms-tile-color"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileImage",
                href: "".concat("https://www.leaseloco.com", "/ms-icon-144x144.png")
            }, "ms-tile-image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }, "theme-color"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "o7ymSALxCvA53q_2pxX9Q2U8MnP_1KO_2161Oj_faTQ"
            }, "google-site-verification"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "fb:app_id",
                content: "2133178003609549"
            }, "fb-app-id"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "url",
                content: url
            }, "url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonical ? canonical : url
            }, "canonical"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "image",
                content: constants/* constants.imageHost.social */._G.imageHost.social
            }, "image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "LeaseLoco"
            }, "author"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: image ? image : constants/* constants.imageHost.social */._G.imageHost.social
            }, "og:image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "LeaseLoco"
            }, "og:site_name"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "article"
            }, "og:type"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:author",
                content: "https://www.facebook.com/leaseloco/"
            }, "og:article:author"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:publisher",
                content: "https://www.facebook.com/leaseloco/"
            }, "og:article:publisher"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }, "twitter:card"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "@leaseloco"
            }, "twitter:site"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: "@leaseloco"
            }, "twitter:creator"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }, "twitter:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image:src",
                content: image ? image : constants/* constants.imageHost.social */._G.imageHost.social
            }, "twitter:image:src"),
            noIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }, "robots"),
            isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context" : "https://schema.org",\n              "@type" : "Organization",\n              "name" : "LeaseLoco",\n              "url" : "https://www.leaseloco.com/",\n              "sameAs" : [\n                "https://www.facebook.com/leaseloco/",\n                "https://twitter.com/leaseloco",\n                "https://www.youtube.com/leaseloco",\n                "https://www.instagram.com/leaseloco/"\n              ]\n            }\n          '
            }, "schema-organization"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n          {\n            "@context": "https://schema.org",\n            "@type": "Service",\n            "provider": {\n                "@type": "Organization",\n                "name": "LeaseLoco",\n                "address": {\n                    "@type": "PostalAddress",\n                    "streetAddress": "33 Arx Technology Centre, James Watt Avenue",\n                    "postalCode": "G75 0QD",\n                    "addressRegion": "Scotland",\n                    "addressLocality": "Glasgow",\n                    "addressCountry": "https://www.wikidata.org/wiki/Q145",\n                    "name": "Postal Address",\n                    "@id": "'.concat(url, '"\n                },\n                "description": "').concat(description, '",\n                "@id": "').concat(url, '"\n            },\n            "logo": "https://assets.leaseloco.com/logos/dark.svg",\n            "brand": {\n                "@type": "Organization",\n                "name": "LeaseLoco"\n            },\n            "url": "').concat(url, '",\n            "areaServed": "https://www.wikidata.org/entity/Q145",\n            "description": "').concat(description, '",\n            "name": "LeaseLoco",\n            "@id": "').concat(url, '"\n          }\n        ')
            }, "schema-service"),
            !!collectionPage && collectionPage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context":"https://schema.org",\n              "@type":"CollectionPage",\n              "@id":"'.concat(url, '",\n              "mainEntity":{\n                "@type":"ItemList",\n                "itemListOrder":"ItemListOrderDescending",\n                "numberOfItems":"').concat(collectionPage.length, '",\n                "itemListElement": [\n                  ').concat(collectionPage.map(function(vehicle, index) {
                    return '{\n                      "@type":"ListItem",\n                      "position":"'.concat(index + 1, '",\n                      "item":{\n                        "@type": "Product",\n                        "image": "').concat((0,utilities_vehicle/* getVehicleHeroImage */.Nk)(vehicle.profileImage), '",\n                        "name": "').concat(vehicle.manufacturer, " ").concat(vehicle.model, '",\n                        "url": "').concat("https://www.leaseloco.com", "/car-leasing/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.manufacturer), "/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.model), "/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.derivative), "/").concat(vehicle.vehicleId, "/").concat(vehicle.profile.leaseType, "-").concat(vehicle.profile.term, "-").concat(vehicle.profile.mileage, "-").concat(vehicle.profile.initialPaymentInMonths, '-0",\n                        "description": "').concat(vehicle.manufacturer, " ").concat(vehicle.model, " ").concat(vehicle.derivative, '",\n                        "itemCondition": "https://schema.org/NewCondition",\n                        "offers": {\n                          "@type": "Offer",\n                          "price": "').concat(vehicle.profile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(vehicle.profile.price) : vehicle.profile.price, '",\n                          "priceCurrency": "GBP",\n                          "availability": "').concat(vehicle.inStock ? "https://schema.org/InStock" : "https://schema.org/PreOrder", '",\n                          "url": "').concat("https://www.leaseloco.com", "/car-leasing/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.manufacturer), "/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.model), "/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.derivative), "/").concat(vehicle.vehicleId, "/").concat(vehicle.profile.leaseType, "-").concat(vehicle.profile.term, "-").concat(vehicle.profile.mileage, "-").concat(vehicle.profile.initialPaymentInMonths, '-0",\n                        },\n                        "brand": {\n                          "@type": "Organization",\n                          "name": "').concat(vehicle.manufacturer, '"\n                        },\n                        "review": [\n                          {\n                            "@type": "Review",\n                            "itemReviewed": {\n                              "@type": "Offer",\n                              "name": "').concat(vehicle.manufacturer, " ").concat(vehicle.model, " ").concat(vehicle.derivative, " (").concat(vehicle.profile.term, " Months, ").concat(vehicle.profile.mileage, " Miles and ").concat(vehicle.profile.initialPaymentInMonths, ' Months Upfront)",\n                            },\n                            "reviewRating": {\n                              "@type": "Rating",\n                              "bestRating": "100",\n                              "ratingValue": "').concat(vehicle.rating, '"\n                            },\n                            "author": {\n                              "@type": "Organization",\n                              "name": "LeaseLoco"\n                            }\n                          }\n                        ]\n                      }\n                    }');
                }), "\n                ]\n              }\n            }\n          ")
            }, "schema-collection-page"),
            !!blogArticle && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context": "https://schema.org",\n              "@type": "BlogPosting",\n              "mainEntityOfPage": {\n                "@type":"WebPage",\n                "@id":"'.concat(url, '"\n              },\n              "headline": "').concat(blogArticle.title, '",\n              "description": "').concat(blogArticle.metaDescription ? blogArticle.metaDescription : blogArticle.description.replace(/<[^>]*>?/gm, ""), '",\n              "datePublished": "').concat(dayjs_min_default()(blogArticle.pubDate).tz("Europe/London").format(), '",\n              "datemodified": "').concat(dayjs_min_default()(blogArticle.pubDate).tz("Europe/London").format(), '",\n              "image": {\n                "@type": "imageObject",\n                "url": "').concat(blogArticle.thumbnail, '",\n                "height": "600",\n                "width": "800"\n              },\n              "publisher": {\n                "@type": "Organization",\n                "name": "LeaseLoco",\n                "logo": {\n                  "@type": "imageObject",\n                  "url": "https://assets.leaseloco.com/logos/dark.svg"\n                }\n              },\n              "author": {\n                "@type": "Person",\n                "name": "').concat(blogArticle.author, '",\n                "jobTitle": "Head of Content"\n              },\n              "sharedContent": [\n                {\n                  "@type":"WebPage",\n                  "headline": "').concat(blogArticle.title, '",\n                  "url": "').concat(url, '",\n                  "author": {\n                    "@type":"Person",\n                    "name": "').concat(blogArticle.author, '",\n                    "jobTitle": "Head of Content"\n                  }\n                }\n              ],\n              "articleBody": "').concat(remove_markdown_default()(blogArticle.body).replace(constants/* constants.regExp.findNewLines */._G.regExp.findNewLines, " "), '"\n            }\n          ')
            }, "schema-blog-article"),
            !!faqs && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context": "https://schema.org",\n              "@type": "FAQPage",\n              "mainEntity": ['.concat(faqs.map(function(faq) {
                    return JSON.stringify({
                        "@type": "Question",
                        name: "".concat(faq.title),
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "".concat(remove_markdown_default()(faq.body).replace(constants/* constants.regExp.findNewLines */._G.regExp.findNewLines, " "))
                        }
                    });
                }), "]\n            }\n          ")
            }, "schema-faqs"),
            contentExists && !!results && results.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context": "https://schema.org/",\n              "@type": "Product",\n              "name": "'.concat(vehicle.manufacturerName, " ").concat(vehicle.modelName, " ").concat(vehicle.derivativeName, " (").concat(leaseProfile.term, " Months, ").concat(leaseProfile.mileage, " Miles and ").concat(leaseProfile.initialPaymentInMonths, ' Months Upfront)",\n              "image": "').concat(image, '",\n              "description": "').concat(description, '",\n              "itemCondition": "https://schema.org/NewCondition",\n              "brand": {\n                "@type": "Organization",\n                "name": "').concat(vehicle.manufacturerName, '"\n              },\n              "offers": {\n                "@type": "AggregateOffer",\n                "priceCurrency": "GBP",\n                "highPrice": "').concat(leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(results[results.length - 1].vehiclePrice.monthlyPayment) : results[results.length - 1].vehiclePrice.monthlyPayment.toFixed(2), '",\n                "lowPrice": "').concat(leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(results[0].vehiclePrice.monthlyPayment) : results[0].vehiclePrice.monthlyPayment.toFixed(2), '",\n                "offerCount": "').concat(results.length, '",\n                "itemCondition": "https://schema.org/NewCondition",\n                "availability": "').concat(leaseProfile.inStock === 1 ? "https://schema.org/InStock" : "https://schema.org/PreOrder", '",\n                "offers": [\n                  ').concat(results.map(function(price) {
                    return JSON.stringify({
                        "@type": "Offer",
                        // "url": router.asPath + "/" + price.vehiclePrice.id,
                        priceCurrency: "GBP",
                        price: "".concat(leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(price.vehiclePrice.monthlyPayment) : price.vehiclePrice.monthlyPayment.toFixed(2)),
                        seller: {
                            "@type": "Organization",
                            name: "".concat(price.supplier.name)
                        }
                    });
                }), "\n                ]\n              }\n            }\n          ")
            }, "schema-product"),
            contentExists && vehicle.type === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: '\n            {\n              "@context": "https://schema.org/",\n              "@type": "Car",\n              "name": "'.concat(vehicle.manufacturer, " ").concat(vehicle.model, " ").concat(vehicle.derivative, '",\n              "image": "').concat(image, '",\n              "itemCondition": "https://schema.org/NewCondition",\n              "manufacturer": {\n                "@type": "Organization",\n                "name": "').concat(vehicle.manufacturer, '"\n              },\n              "fuelType": "').concat(vehicle.fuelType, '",\n              "vehicleConfiguration": "').concat(vehicle.derivative, '",\n              "vehicleTransmission": "').concat(vehicle.transmissionType, '",\n              "bodyType": "').concat(vehicle.bodyStyle, '",\n              "offers": [\n                {\n                  "@type": "Offer",\n                  "priceCurrency": "GBP",\n                  "price": "').concat(!!results && results.length > 0 ? leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(results[0].vehiclePrice.monthlyPayment) : results[0].vehiclePrice.monthlyPayment.toFixed(2) : 0, '",\n                  "seller": {\n                    "@type": "Organization",\n                    "name": "').concat(!!results && results.length > 0 && results[0].supplier.name, '"\n                  },\n                  "url": "').concat(router.asPath, '",\n                  "itemCondition": "https://schema.org/NewCondition"\n                }\n              ]\n            }\n          ')
            }, "schema-vehicle")
        ]
    });
};
PageMetaData.propTypes = {
    title: (prop_types_default()).string.isRequired,
    description: (prop_types_default()).string.isRequired,
    pageUrl: (prop_types_default()).string.isRequired,
    image: (prop_types_default()).string,
    collectionPage: (prop_types_default()).array,
    blogArticle: (prop_types_default()).object,
    faqs: (prop_types_default()).array,
    noIndex: (prop_types_default()).bool,
    canonical: (prop_types_default()).string,
    isHomePage: (prop_types_default()).bool,
    vehicle: (prop_types_default()).object,
    leaseProfile: (prop_types_default()).object,
    results: (prop_types_default()).array
};

;// CONCATENATED MODULE: ./components/atomic/PageMetaData/index.ts



/***/ })

}]);